<template>
  <div class="container-fluid navigation-bar p-1 px-2">

    <button @click="toggle" class="burger">
      <font-awesome-icon icon="fa-solid fa-bars"/>
    </button>

    <div class="navbar-logo"></div>
    <div class="navigation-box d-flex justify-content-center">
      <span v-if="$store.getters.getOpenTableName && $store.getters.getDeviceSettings && $store.getters.getDeviceSettings.PosType !== 'Touch' && $route.name === `pos`"
            class="fw-bolder mt-2 text-white">{{ $store.getters.getOpenTableName }}</span>
    </div>
    <div class="device-icon-container d-flex align-items-center">
      <font-awesome-icon v-if="isAndroid" :icon="['fas', 'phone']" class="device-icon" />
      <font-awesome-icon v-else :icon="['fas', 'laptop']" class="device-icon" />
    </div>

    <div class="user-settings">
      <a class="burger float-start mx-3" v-if="showLoyalty" @click="checkLoyalty">
        <font-awesome-icon icon="heart-circle-check" v-if="!!$store.getters.getLoyaltyDetails.barcode"/>
        <font-awesome-icon icon="heart-circle-plus" v-else/>
      </a>

      <Notification/>

      <a class="burger mx-4" v-if="readyOrders > 0" @click="openKitchenOrders">
        <span class="text-warning notification-badge">{{ readyOrders }}</span>
        <font-awesome-icon icon="bowl-food"/>
        <audio ref="audioPlayer" src="@/assets/notification.mp3"></audio>
      </a>
      <a style="display: none" id="interact-btn"></a>

      <button @click="syncData" class="burger">
        <font-awesome-icon icon="arrows-rotate"/>
      </button>
    </div>
    <custom-modal title="Add Loyalty Customer To Sale" ref="scanLoyalty" @open="focusInput">
      <div v-if="!loyaltyDetails.barcode">
        <label for="loyalty-barcode">Scan Barcode</label>
        <input type="text" class="form-control" :disabled="$store.getters.getLoadingState" id="loyalty-barcode"
               v-model="loyaltyBarcode" ref="loyaltyCode"
               @keyup.enter="validateBarcode">
      </div>
      <div class="d-flex flex-column" v-else>
        <span class="text-sm text-secondary">Barcode : {{ loyaltyDetails.barcode }}</span>
        <div class="d-flex flex-row">
          Customer : {{ loyaltyDetails.name }} {{ loyaltyDetails.surname }}
          <a class="btn btn-sm btn-outline-primary mx-2" @click="$store.commit(`setLoyaltyDetails`,{})">
            <font-awesome-icon icon="close"/>
          </a>
        </div>
        <span>Contact : {{ loyaltyDetails.contact }}</span>
        Points Value : {{ loyaltyDetails.balance }} points - ({{ $utils.formatMoney(loyaltyDetails.pointsInCash) }})

      </div>
    </custom-modal>
    <div class="customer-details">

    </div>

    <!--        modal for buying a voucher starts here-->
    <button id="openCustomerInformationModalButton" class="btn btn-primary d-none" data-bs-toggle="modal"
            data-bs-target="#amountInputModal">Open Amount Input Modal
    </button>
    <!-- Modals -->
    <!-- Modal for Amount Input -->
    <div class="modal fade" id="amountInputModal" tabindex="-1" aria-labelledby="amountInputModalLabel"
         aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="amountInputModalLabel">Enter Amount</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <div class="mb-3">
              <label for="customerPhoneNumber" class="form-label">cell Number</label>
              <input type="tel" class="form-control" id="customerPhoneNumber" v-model="cell" min="10" maxlength="10"
                     placeholder="Enter phone number" required>
            </div>
            <div class="mb-3">
              <label for="cell" class="form-label">Amount</label>
              <input type="number" class="form-control" id="cell" v-model="amount" placeholder="Enter amount"
                     required>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" id="amountCloseBtn" data-bs-dismiss="modal">Close</button>
            <button type="button" class="btn btn-primary" @click="handleAmountInputSave">Save</button>
          </div>
        </div>
      </div>
    </div>
    <button id="openAmountInputModalButton" class="btn btn-primary d-none" data-bs-toggle="modal"
            data-bs-target="#customerInfoModal">Open Customer Information Modal
    </button>
    <!-- Modal for Customer Information -->
    <div class="modal fade" id="customerInfoModal" tabindex="-1" @hidden.bs.modal="resetCustomerInfoFields"
         aria-labelledby="customerInfoModalLabel" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="customerInfoModalLabel">Enter Customer Information</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <div class="mb-3">
              <label for="phoneNumber" class="form-label">cell Number</label>
              <input type="tel" class="form-control" id="phoneNumber" maxlength="10" v-model="cell"
                     placeholder="Enter phone number" required>
            </div>

          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" id="closemodal" data-bs-dismiss="modal">Close</button>
            <button type="button" class="btn btn-primary" @click="handleCustomerInfoSave">Save</button>
          </div>
        </div>
      </div>
    </div>
    <div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-xl">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">Voucher Purchasing Screen</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body" style="max-height: 75vh; overflow-y: auto;">
            <div class="row">
              <!-- Left side: existing design -->
              <div class="col-md-4">
                <div class="list-group">
                  <a class="list-group-item list-group-item-action" v-for="(option, index) in options" :key="index"
                     @click="selectOption(option)">
                    {{ option }}
                  </a>
                </div>
              </div>
              <!-- Right side: list of other clickable options -->
              <div class="col-md-8">
                <div class="product-card" v-for="item in selectedItem" :key="item.PLU" @click="checkItemOffer(item)">
                  <div class="stock-card_img mx-2 mt-2" v-if="item.Image">
                    <img :src="item.Image" alt="Item Image">
                  </div>
                  <div class="card-body mx-3 p-1 d-flex justify-content-between flex-column">
                    <span class="text-secondary text-sm">Stock Code : {{ item.PLU }}</span>
                    <h6 class="product-description">
                      {{ item.Description }} <br>
                      <span class="product-description2">{{ item.Description2 }}</span>
                    </h6>
                    <h5 class="product-price">{{ $utils.formatMoney(item.SellingIncl) }}</h5>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" id="closebutton" data-bs-dismiss="modal">Close</button>
          </div>
        </div>
      </div>
    </div>
    <!--        modal ends for voucher-->

  </div>
</template>

<script>


import Notification from "@/components/layout/navigation/Notification";
import CustomModal from "@/components/layout/utils/CustomModal";

export default {
  name: "NavigationBar",
  components: {Notification, CustomModal},
  beforeMount() {
    this.checkReadyOrders()
  },

  mounted() {
    this.interval = setInterval(() => {
      this.checkReadyOrders();
    }, 30000);
  },
  beforeDestroy() {
    clearInterval(this.interval);
  },
  computed: {
    currentSale() {
      return this.$store.getters.getCurrentSale
    },
    options() {
      return this.$store.getters.getZedMobileCategories;
    },
    tipAmount() {
      let tipAmount = this.$store.getters.getTipAmount;
      return tipAmount;
    },
    disabled() {
      return this.saleTotal <= 0;
    },
    customer() {
      let id = this.$store.getters.getCustomer;
      return this.$store.getters.getDebtorByID(id);
    },
    currentSaleLines() {
      return this.$store.getters.getSaleLines
    },
    saleUnits() {
      return this.$store.getters.getSaleUnits
    },
    saleTotal() {
      return this.$store.getters.getSaleTotal + this.$store.getters.getTipAmount
    },
    discount() {
      return this.$store.getters.getSaleDiscount
    },
    tipsTotal() {
      return this.$store.getters.getTipAmount;
    },
    color() {
      return this.disabled ? {background: 'grey'} : {background: '#9ccc65'}
    },


    salesScreens() {
      return [`pos`, `payment`, `split-payment`, `instruction`]
    },
    showLoyalty() {
      let isSalesScreen = this.salesScreens.includes(this.$route.name);
      return this.$store.getters.getHasLoyalty && isSalesScreen;
    },
    loyaltyDetails() {
      return this.$store.getters.getLoyaltyDetails;
    },
    isAndroid() {
      const isAndroidDevice = navigator.userAgent.toLowerCase().includes('android');
      return isAndroidDevice;
    },
    readyOrders() {
      return this.$store.getters.getReadyOrdersCount;
    }
  },
  data() {
    return {
      loyaltyBarcode: null,
      selectedCategory: null,
      selectedItem: [],
      amount: '', // Bind to Amount input
      cell: '', // Bind to Phone Number input
      amountPaid: '', // Bind to Amount Paid input
      currentItem: null, // To track the currently selected item      saleNumber: this.$route.query.saleNumber,

    }
  },
  props: {
    toggle: {
      type: Function,
      require: true
    },
  },
  methods: {
    syncData() {
      return window.location.reload(true);
    },
    checkLoyalty() {
      return this.$refs.scanLoyalty.openModal();
    },
    tawkTo() {
      return window.open('https://tawk.to/LytSupport', '_self');
    },
    checkReadyOrders() {
      return this.$store.dispatch(`checkReadyOrders`)
          .then(res => {
            try {
              document.getElementById(`interact-btn`).click();
            } catch (e) {
            }
            if (res) return this.playSound();
          });
    },
    playSound() {
      this.$refs.audioPlayer.play();
    },
    validateBarcode() {
      if (!isValidString(this.loyaltyBarcode)) return;
      this.$refs.scanLoyalty.closeModal();
      this.$utils.showLoading()
      return this.$store.dispatch(`checkLoyaltyBarcode`, this.loyaltyBarcode)
          .finally(() => {
            this.loyaltyBarcode = null;
            this.$refs.scanLoyalty.openModal();
          })
    },
    async focusInput() {
      if (!!this.loyaltyDetails.barcode) return;
      await new Promise(resolve => setTimeout(resolve, 1000));
      return this.$refs.loyaltyCode.focus();
    },
    openKitchenOrders() {
      return this.$router.push({name: `kitchen-orders`})
    },
    resetAmountInputFields() {
      this.amount = '';
      this.cell = '';
      document.getElementById("amountCloseBtn").click();
    },
    handleAmountInputSave() {
      if (this.currentItem) {
        this.addToSaleWithAmount({
          ...this.currentItem,
          amount: this.amount,
          cell: this.cell,

        });
        this.resetAmountInputFields()
      }
    },
    handleCustomerInfoSave() {
      if (this.currentItem) {
        this.addToSaleWithPhoneNumber({
          ...this.currentItem,
          cell: this.cell,
        });
        this.resetCustomerInfoFields()
      }
    },
    resetCustomerInfoFields() {
      this.cell = '';
      document.getElementById("closemodal").click();
    },
    addToSaleWithAmount(item) {
      let obj = {
        Plu: item.PLU,
        Description: item.Description,
        Qty: 1,
        Unit: item.amount,
        Line: item.amount,
        Discount: 0,
        vat: 0,
        tourismLevy :0,
        instructions: [],
        voucher: true,
        cell: item.cell || "",
        offer: item.offer || "",
      };
      this.$store.commit('addToCurrentSaleLines', obj);
      this.$store.dispatch('calculateTipAmount');
    },
    addToSaleWithPhoneNumber(item) {
      let obj = {
        Plu: item.PLU,
        Description: item.Description,
        Qty: 1,
        Unit: item.SellingIncl,
        Line: item.SellingIncl,
        Discount: 0,
        vat: 0,
        instructions: [],
        tourismLevy : 0,
        voucher: true,
        offer: item.offer || "",
        cell: item.cell || "", // Add phoneNumber or any other required data
      };
      this.$store.commit('addToCurrentSaleLines', obj);
      this.$store.dispatch('calculateTipAmount');
    },
    checkItemOffer(item) {
      this.currentItem = item; // Track the selected item
      const hasOffer = item.offer;

      if (hasOffer) {
        this.triggerModal('openAmountInputModalButton');
      } else {
        this.triggerModal('openCustomerInformationModalButton');
      }
    },
    triggerModal(buttonId) {
      const button = document.getElementById(buttonId);
      if (button) {
        button.click();
      }
    },
    selectOption(option) {
      this.$utils.showLoading();
      this.selectedCategory = option;
      return axios.get(zedMobileApi + 'products/getByCatgeory', {
        params: {category: option},
        headers: {"Api-key": this.$store.getters.getZedMobileApiKey}
      }).then(response => this.selectedItem = response.data)
          .catch(error => errorHandler.tomcatError(error))
          .finally(() => this.$utils.hideLoading());
    },
    selectCustomer() {
      return this.$router.push({name: `select-customer`, query: {saleNumber: this.$route.query.saleNumber}})
    },
    unselectCustomer() {
      this.$store.commit(`setCustomer`, '')
    },
    close() {
      return this.$router.push({name: 'pos'})
    },
    saveTable() {
      let close = document.getElementById(`canvasClose`);
      if (close) close.click();
      if (!this.currentSale || this.currentSale === 0) {
        return this.createTable();
      }
      return this.editTable();
    },
    loadPanel() {
      return Swal.fire({
        html: 'Updating table....',
        allowOutsideClick: false,
        timerProgressBar: true,
        didOpen: () => {
          Swal.showLoading()
        },
      });
    },
    editTable() {
      let settings = this.$store.getters.getDeviceSettings;
      let table = {};
      this.loadPanel()
      table.items = this.$store.getters.getSaleLines;
      table.Customer = this.$store.getters.getCustomer;
      table.name = this.$store.getters.getOpenTableName;
      return this.$store.dispatch('updateTable', table)
          .then(() => {
            responses.showInfo('Table successfully updated')
            let autoLogout = settings.AutoLog === 1;
            if (autoLogout) {
              return this.$router.push({name: `poslogin`});
            }
            return this.$router.push({name: `tables`})
          }).finally(() => Swal.close())
    },
    createTable() {
      this.$store.commit('setIsTabOpen', true)
      return Swal.fire({
        title: 'Table Name',
        icon: 'question',
        input: 'text',
        showCancelButton: true,
        confirmButtonText: 'Save Table',
        showLoaderOnConfirm: true,
        allowOutsideClick: false,
        preConfirm: (input) => {
          if (!input) return Swal.showValidationMessage(`Table name is required`);
          this.$store.commit(`setOpenTableName`, input)
          return this.$store.dispatch('saveNewTable', {
            name: input,
            Customer: this.$store.getters.getCustomer,
          }).then(() => input)
              .catch(error => Swal.showValidationMessage(error))
        },
      }).then((result) => {
        this.$store.commit('setIsTabOpen', false)
        if (result.isConfirmed) {
          return Swal.fire({
            title: `Success`,
            icon: 'success',
            text: `Table ${result.value} Saved`
          }).then(() => this.$router.push({name: `tables`}))
        }
      })
    },

    /**
     * Routes to the `payment` route to complete the sale.
     * Does NOT mutate sale state (cart/discount/tip preserved).
     * @returns {Promise} resolves when navigation has been triggered.
     */
    process() {
      return this.$router.push({name: 'payment'})
    },
    /**
     * "Delivery" click handler.
     *
     * Intended behaviour: only the tip should be cleared — cart,
     * discount, customer and table must remain so the delivery
     * payment can still be taken.
     *
     * Current behaviour: only `setTipAmount(0)` is committed before
     * navigating to the `payment` route via `process()`. Nothing else
     * is cleared by this handler.
     *
     * NOTE — investigation 2026-07-23 (Athena): Reference clone. Same
     * handler shape as Lytning Restaurant POS. Any "extra clearing"
     * perception in Lytning is NOT introduced here. See notes in
     * PaymentControls.vue (processDelivery) and the related notes in
     * the Lytning `PaymenScreen.vue#back()` and `clearSale` mutation.
     */
    processDelivery() {
      this.$store.commit(`setTipAmount`, 0)
      return this.process();
    },
    scrollToTop() {
      const newScrollTop = Math.max(this.scrollPosition - 110, 0);
      this.$refs.shoppingCart.scrollTo({
        top: newScrollTop,
        behavior: 'smooth',
      });
    },
    scrollToBottom() {
      const newScrollTop = Math.min(this.scrollPosition + 110, this.maxScrollTop);
      this.$refs.shoppingCart.scrollTo({
        top: newScrollTop,
        behavior: 'smooth',
      });
    },
    handleScroll() {
      const scroll = {
        scrollTop: this.$refs.shoppingCart.scrollTop,
        scrollHeight: this.$refs.shoppingCart.scrollHeight,
        clientHeight: this.$refs.shoppingCart.clientHeight
      }
      this.scrollPosition = scroll.scrollTop
      this.maxScrollTop = scroll.scrollHeight - scroll.clientHeight
      this.isScrollable = scroll.scrollHeight > scroll.clientHeight;
    },
  }
}
</script>

<style lang="scss" scoped>

.burger {
  width: 40px;
  height: 40px;
  background: transparent;
  color: white;
  font-size: 30px;
  float: right;
}

.user-settings {
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
}
.device-icon-container {
  display: flex;
  align-items: center;
  margin-left: 20px;
}

.device-icon {
  font-size: 30px;
  color: white;
}
.sales-panel {
  display: flex;
  flex-direction: column;
  padding: 0;
  position: relative;

  .sale-header {
    background: #F2F2F4;
    box-shadow: 0 2px 8px 0 rgba(203, 153, 126, 0.4);
    border: 1px solid #E6E7EC;
    height: 53px;
    max-height: 55px;

    .header {
      display: flex;
      flex-direction: row;
      align-items: center;

      h2 {
        margin: 0;
      }

      button {
        width: 30px;
        background: white;
        font-size: 25px;
      }
    }
  }

  @media (min-height: 769px) {
    .sale-lines-table {
      height: 83vh !important;
    }
  }

  .sale-lines-table {
    flex: auto;
    overflow-y: auto;
    height: 77vh;

    .sales-list {
      list-style: none;
      padding: 0 0 130px 0;

      li {
        border: 1px solid #E6E7EC;
      }
    }
  }

  .sale-stats {
    position: absolute;
    background: #F2F2F4;
    border: 1px solid #E6E7EC;
    max-height: 163px;
    bottom: 0;
    left: 0;
    right: 0;
  }
}

.list-group-item {
  font-size: 1.5rem; /* Increased font size */
  padding: 15px 20px; /* Increased padding */
}

h4, h5, h6 {
  margin: 0;
}

.example-card-img-responsive {
  width: 80px;
  height: 65px;
  margin: 10px;
  opacity: 0.8;
}

.product-card {
  height: 110px;
  transition: 200ms ease-in-out;
  overflow: hidden;
  width: 100%;
  background-color: #fff;
  border: 1px solid rgba(0, 0, 0, 0.125);
  border-radius: 0.25rem;
  display: flex;
  flex-direction: row;
  word-wrap: break-word;

  .product-description {
    font-weight: 600;
    color: #303030;
  }

  .product-description2 {
    font-weight: 400;
    color: #303030;
  }

  .product-price {
    font-weight: 700;
    color: #322f2f;
  }

  &:hover, &:focus {
    background: #0092f7;
    color: white;
    transform: scale(1.03);

    .product-description {
      color: white;
    }

    .product-price {
      color: white;
    }
  }
}

img {
  height: 94px;
  width: 94px;
  opacity: 0.7;
  border-radius: 10px;
}

.text-sm {
  font-size: 12px !important;
}
</style>
